module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('icon', {
    staticClass: "fa-spin",
    attrs: {
      "name": "circle-o-notch",
      "scale": "2"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.text.loading')) + "\n")], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9056d760"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/LoadingSpinner.vue
// module id = 1846
// module chunks = 1